import defaultApi from '@/utils/request';

export default {
  Load(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_StudentReservation/Load',
      params,
    });
  },
  Get(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_StudentReservation/Get',
      params,
    });
  },
  Add(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_StudentReservation/Add',
      data,
    });
  },
  LoadReservationStd(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_StudentReservation/LoadReservationStd',
      params,
    });
  },
  Update(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_StudentReservation/Update',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data,
    });
  },
  FindByCourseId(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_StudentReservation/FindByCourseId',
      params,
    });
  },
  FindByCourseIdStd(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_StudentReservation/FindByCourseIdStd',
      params,
    });
  },
  FindByOrderNo(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_StudentReservation/FindByOrderNo',
      params,
    });
  },
  DeleteByCourseId(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_StudentReservation/DeleteByCourseId',
      data,
      headers: { 'Content-Type': 'application/json-patch+json' },
    });
  },
  ChangeReserveStatus(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_StudentReservation/ChangeReserveStatus',
      data,
      headers: { 'Content-Type': 'application/json-patch+json' },
    });
  },
  LoadClientTeacher(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_StudentReservation/LoadClientTeacher',
      params,
    });
  },
  LoadClientStudent(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_StudentReservation/LoadClientStudent',
      params,
    });
  },
  Signup(data) {
    return defaultApi({
      method: 'Post',
      url: 's7x_StudentReservation/Signup',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data,
    });
  },
  ChangeSignup(data) {
    return defaultApi({
      method: 'Post',
      url: 's7x_StudentReservation/ChangeSignup',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data,
    });
  },
  ChangeTeacher(data) {
    return defaultApi({
      url: 's7x_StudentReservation/ChangeTeacher',
      method: 'post',
      data,
    });
  },
  CancelReservation(data) {
    return defaultApi({
      url: 's7x_StudentReservation/CancelReservation',
      method: 'post',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data,
    });
  },
  Delete(data) {
    return defaultApi({
      url: 's7x_StudentReservation/Delete',
      method: 'post',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data,
    });
  },
};
